export default [
    {id: 10, name: 'Owner'},
    {id: 20, name: 'Admin'},
    {id: 30, name: 'Editor'},
    {id: 35, name: 'Return Manager'},
    {id: 40, name: 'User'}
];
